import {
  GenerateAgreementsForAutopayError,
  GenerateAgreementsForAutopayResult,
  GenerateAgreementsForAutopayResultTypenames,
  GenerateAgreementsForAutopaySuccess,
  GenerateAgreementsForDisbursementError,
  GenerateAgreementsForDisbursementResult,
  GenerateAgreementsForDisbursementResultTypenames,
  GenerateAgreementsForDisbursementSuccess,
} from '@varo/graphql-schema-types';

export const isGenerateAgreementsForAutoPaySuccess = (
  autoPayAgreement: GenerateAgreementsForAutopayResult | undefined,
): autoPayAgreement is GenerateAgreementsForAutopaySuccess => {
  return (
    autoPayAgreement?.__typename ===
    GenerateAgreementsForAutopayResultTypenames.GenerateAgreementsForAutopaySuccess
  );
};

export const isGenerateAgreementsForAutoPayError = (
  autoPayAgreement: GenerateAgreementsForAutopayResult | undefined,
): autoPayAgreement is GenerateAgreementsForAutopayError => {
  return (
    autoPayAgreement?.__typename ===
    GenerateAgreementsForAutopayResultTypenames.GenerateAgreementsForAutopayError
  );
};

export const isGenerateAgreementsForDisbursementSuccess = (
  disbursementAgreements: GenerateAgreementsForDisbursementResult | undefined,
): disbursementAgreements is GenerateAgreementsForDisbursementSuccess => {
  return (
    disbursementAgreements?.__typename ===
    GenerateAgreementsForDisbursementResultTypenames.GenerateAgreementsForDisbursementSuccess
  );
};

export const isGenerateAgreementsForDisbursementError = (
  autoPayAgreement: GenerateAgreementsForDisbursementResult | undefined,
): autoPayAgreement is GenerateAgreementsForDisbursementError => {
  return (
    autoPayAgreement?.__typename ===
    GenerateAgreementsForDisbursementResultTypenames.GenerateAgreementsForDisbursementError
  );
};
